module.exports = __webpack_public_path__ + "static/media/22792484_1629545590453959_7801448968646844528_o.633d3cab.jpg";